module.exports = __webpack_public_path__ + "img/map.663a5108.png";